import { Injectable } from '@angular/core';
import { ISignup, ISignupAccount, ISignupUser } from '@app/models/signup';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import {
  UpdateAccount,
  UpdateApprovals,
  UpdateCredential,
  UpdateLegalEntity,
  UpdatePersonnalInformation,
  UpdatePhone,
} from '../actions/signup.action';
import { SignupStateModel } from '../model/state.model';

@State<SignupStateModel>({
  name: 'signupState',
  defaults: {
    signup: {
      user: null,
      account: null,
      cgu_acceptance: false,
      mailing_acceptance: false,
    },
  },
})
@Injectable()
export class SignupState {
  @Selector()
  static signupModel(state: SignupStateModel): ISignup {
    return state.signup;
  }

  @Selector()
  static signupAccount(state: SignupStateModel): ISignupAccount {
    return state.signup.account;
  }

  @Selector()
  static signupUser(state: SignupStateModel): ISignupUser {
    return state.signup.user;
  }

  @Selector()
  static legalEntity(state: SignupStateModel): string {
    return state.signup.account.legal_entity_type;
  }

  @Action(UpdateLegalEntity)
  updateLegalEntity({ getState, patchState }: StateContext<SignupStateModel>, { legalEntity }: UpdateLegalEntity) {
    patchState({
      signup: {
        ...getState().signup,
        account: {
          ...getState().signup.account,
          legal_entity_type: legalEntity.legal_entity_type,
          name: legalEntity.name,
          zefix_uid: legalEntity.zefix_uid,
        },
      },
    });
  }

  @Action(UpdateAccount)
  updateAccount({ getState, patchState }: StateContext<SignupStateModel>, { account }: UpdateAccount) {
    patchState({
      signup: {
        ...getState().signup,
        account: {
          ...getState().signup.account,
          ...account,
        },
      },
    });
  }

  @Action(UpdatePersonnalInformation)
  updatePersonnalInformation(
    { getState, patchState }: StateContext<SignupStateModel>,
    { personnalInformation }: UpdatePersonnalInformation
  ) {
    patchState({
      signup: {
        ...getState().signup,
        user: {
          ...getState().signup.user,
          ...personnalInformation,
        },
      },
    });
  }

  @Action(UpdatePhone)
  updatePhone({ getState, patchState }: StateContext<SignupStateModel>, { personnalInformation }: UpdatePhone) {
    patchState({
      signup: {
        ...getState().signup,
        user: {
          ...getState().signup.user,
          ...personnalInformation,
        },
      },
    });
  }

  @Action(UpdateCredential)
  updateCredential({ getState, patchState }: StateContext<SignupStateModel>, { credential }: UpdateCredential) {
    patchState({
      signup: {
        ...getState().signup,
        user: {
          ...getState().signup.user,
          ...credential,
        },
      },
    });
  }

  @Action(UpdateApprovals)
  updateApprovals({ getState, patchState }: StateContext<SignupStateModel>, { approvals }: UpdateApprovals) {
    patchState({
      signup: {
        ...getState().signup,
        ...approvals,
      },
    });
  }
}
